import React, { useState } from "react";
import { deleteApi } from "../../../../services/api/globalApi";
import { errorMessage, successMessage } from "../../../../utils/toastify-message/ToastifyMessage";
const { forwardRef, useRef, useImperativeHandle } = React;

const DeleteGuarantorModal = forwardRef(({ reGetData, allData, data }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
    },
  }));

  const formHandler = async () => {
    const path = `admin/loans/${allData?._id}/loanGuarantors/${data?.nationalId}`;
    try {
      await deleteApi({ path });
      successMessage("ضامن کاربر با موفقیت حذف شد.");
      reGetData();
      setShowModal(false);
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-30  ${
          !showModal && "hidden"
        }`}
        onClick={() => setShowModal(false)}
      ></div>
      <div
        className={`w-[320px] sm:w-[500px] py-4 max-h-[360px] overflow-y-scroll mt-4 flex items-center justify-center bg-white rounded-lg shadow z-40 rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-160px] sm:mr-[-250px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div>
          <button
            onClick={() => setShowModal(false)}
            type="button"
            className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
            data-modal-hide="popup-modal"
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">بستن مدال</span>
          </button>
          <div className="p-4 md:p-5 text-center">
            <svg
              className="mx-auto mb-4 text-red-500 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              آیا مطمئن هستید که می خواهید ضامن آقا/خانم {data?.name} را حذف
              کنید؟
            </h3>
            <div className="flex items-center justify-center gap-2">
              <button
                onClick={() => setShowModal(false)}
                data-modal-hide="popup-modal"
                type="button"
                className="py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
              >
                خیر
              </button>
              <button
                onClick={formHandler}
                data-modal-hide="popup-modal"
                type="button"
                className="text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm inline-flex items-center px-10 py-2.5 text-center"
              >
                بله
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});
export default DeleteGuarantorModal;
